const InviteType = {
	BOARD: 'board',
	TEAM: 'team',
} as const;

export default InviteType;
